export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Widget-Erstellung für"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stornieren"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generieren"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zahlung in"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zahlungsbetrag"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgsaktionen"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehleraktionen"])}
}